import React, { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import axios from "axiosClient";
import { Formik, Form, Field } from "formik";

import { Colxx } from "../components/common/CustomBootstrap";
import UserLayout from "layout/UserLayout";
import { useToken } from "auth/useToken";
import CustomInput from "components/CustomInput";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "components/LanguageDropdown";

const Register = ({ loading }) => {
  const navigate = useNavigate();
  const [token, setToken] = useToken();
  const { t } = useTranslation();

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const onChangeValues = (e) => {
    if (e.target.name === "phone") {
      setValues({
        ...values,
        [e.target.name]: e.target.value.replace(/\D/g, ""),
      });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
    setErrors({ ...errors, server: null, [e.target.name]: null });
  };

  const validatePhoneNumber = (value) => {
    let rex = /998[0-9]{9}/;
    if (value.length !== 12) {
      setErrors({
        ...errors,
        phone: "Please, enter correct phone number including 998",
      });
      return false;
    } else if (rex.test(value)) {
      setErrors({ ...errors, phone: null });

      return true;
    } else {
      setErrors({
        ...errors,
        phone: "Please, enter correct phone number including 998",
      });
      return false;
    }
  };

  const validateEmail = (value) => {
    let rex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (rex.test(value)) {
      setErrors({ ...errors, email: null });
      return true;
    } else {
      setErrors({ ...errors, email: "Please, enter correct email address" });
      return false;
    }
  };

  const onUserRegister = async (e) => {
    e.preventDefault();
    if (!loading) {
      if (values.firstName === "" || !values.firstName) {
        setErrors({ ...errors, firstName: t("enterFirstName") });
      } else if (values.lastName === "" || !values.lastName) {
        setErrors({ ...errors, lastName: t("enterLastName") });
      } else if (values.phone === "" || !values.phone) {
        setErrors({ ...errors, phone: t("enterPhone") });
      } else if (values.email === "" || !values.email) {
        setErrors({ ...errors, email: t("enterEmail") });
      } else if (values.password === "" || !values.password) {
        setErrors({ ...errors, password: t("enterPassword") });
      } else if (values.password.length < 6) {
        setErrors({
          ...errors,
          password: t("atLeast6"),
        });
      } else if (values.repeatPassword === "" || !values.repeatPassword) {
        setErrors({
          ...errors,
          repeatPassword: t("repeatPassword"),
        });
      } else if (values.password !== values.repeatPassword) {
        setErrors({
          ...errors,
          repeatPassword: t("passwordsNotMatch"),
        });
      } else if (!validatePhoneNumber(values.phone)) {
        setErrors({ ...errors, phone: t("enterCorrectPhone") });
      } else {
        try {
          console.log(values);
          const response = await axios.post("/api/register", values);
          setToken(response.data);
          console.log(response.data);
          if (response.data.success) {
            navigate("/login");
          } else {
            setErrors({
              ...errors,
              server: t("smthWentWrong"),
            });
          }
          // navigate("/home");
        } catch (error) {
          console.log(error.response);
          setErrors({ ...errors, server: error.response.data });
        }
      }
    }
  };

  return (
    <UserLayout>
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">{t("registerTitle")}</p>
              <p className="white mb-0">{t("fillDetails")}</p>
            </div>
            <div className="form-side">
              <div className="d-flex align-items-center justify-content-between">
                <div></div>
                <LanguageDropdown />
              </div>
              <CardTitle className="mb-4">{t("register")}</CardTitle>

              <Formik>
                {() => (
                  <Form
                    className="av-tooltip tooltip-label-bottom"
                    onSubmit={onUserRegister}
                  >
                    <CustomInput
                      label={t("firstName")}
                      name={"firstName"}
                      values={values}
                      onChange={onChangeValues}
                      errors={errors}
                    />
                    <CustomInput
                      label={t("lastName")}
                      name={"lastName"}
                      values={values}
                      onChange={onChangeValues}
                      errors={errors}
                    />
                    <CustomInput
                      label={t("phoneNumber")}
                      name={"phone"}
                      values={values}
                      onChange={onChangeValues}
                      errors={errors}
                    />
                    <CustomInput
                      label={t("email")}
                      name={"email"}
                      type="email"
                      values={values}
                      onChange={onChangeValues}
                      errors={errors}
                    />
                    <FormGroup className="form-group has-float-label">
                      <Label>{t("password")}</Label>
                      <Field
                        className="form-control"
                        type="text"
                        name="password"
                        value={values.password}
                        onChange={onChangeValues}
                      />
                      {errors.password && (
                        <div className="invalid-feedback d-block">
                          {errors.password}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup className="form-group has-float-label">
                      <Label>{t("passwordConfirm")}</Label>
                      <Field
                        className="form-control"
                        type="text"
                        name="repeatPassword"
                        value={values.repeatPassword}
                        onChange={onChangeValues}
                      />
                      {errors.repeatPassword && (
                        <div className="invalid-feedback d-block">
                          {errors.repeatPassword}
                        </div>
                      )}
                    </FormGroup>
                    <p className="text-danger">{errors.server}</p>

                    <div className="d-flex justify-content-between align-items-center">
                      <NavLink to="/login">{t("alreadyRegistered")}</NavLink>
                      <Button
                        type="submit"
                        color="primary"
                        className={`btn-shadow btn-multiple-state ${
                          loading ? "show-spinner" : ""
                        }`}
                        size="lg"
                      >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">{t("register")}</span>
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </Card>
        </Colxx>
      </Row>
    </UserLayout>
  );
};

export default Register;
